export const getInitials = (id) => {
    var _a, _b, _c, _d;
    const profile = (_b = (_a = id === null || id === void 0 ? void 0 : id.identity) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.profile;
    if (!profile)
        return "";
    const first = ((_c = profile.firstname) === null || _c === void 0 ? void 0 : _c.charAt(0)) || "";
    const second = ((_d = profile.lastname) === null || _d === void 0 ? void 0 : _d.charAt(0)) || "";
    return `${first}${second}`.toUpperCase();
};
export const getFullName = (id) => {
    var _a, _b;
    const profile = (_b = (_a = id === null || id === void 0 ? void 0 : id.identity) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.profile;
    if (!profile)
        return "";
    if (!profile.firstname && !profile.lastname)
        return "";
    return `${profile.title} ${profile.firstname} ${profile.lastname}`;
};
